import { sendHttpRequest } from "lib/fetcher";
import useWsSender from "lib/wsSenderHook";

export const changeNvrType = async (nvrId, type, orgId) => {
  return sendHttpRequest({
    url: `/device/nvrs/${nvrId}/type`,
    method: "post",
    data: {
      type,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
};
export const resetGps = async (nvrId, orgId) => {
  return sendHttpRequest({
    url: `/device/nvrs/${nvrId}/reset_nmea`,
    method: "post",
    headers: {
      "x-org-id": orgId,
    },
  });
};
export const useWSService = () => {
  const { sendWsRequest } = useWsSender();
  return {
    testSpeed: (orgId, nvrId) => {
      return sendWsRequest(
        "device.speedtest",
        {
          deviceSpeedTest: {
            deviceId: nvrId,
          },
        },
        { orgId, timeout: 90000 },
      );
    },
    upgradeEdge: (orgId, nvrId) => {
      return sendWsRequest(
        "device.nvr.upgrade",
        {
          nvrUpgrade: {
            id: nvrId,
            service: "nvr_edge",
          },
        },
        { orgId: Number(orgId), timeout: 90000 },
      );
    },
  };
};
export function getMonitorScheduleByCamera(caemraId, orgId) {
  return sendHttpRequest({
    url: `/camera/cameras/${caemraId}/monitoring_schedule`,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function saveMonitoringSchedule(cameraIds, schedule, siteId, orgId) {
  return sendHttpRequest({
    url: `/camera/cameras/monitoring_schedule`,
    method: "post",
    data: {
      camIds: cameraIds,
      camSchedule: schedule,
      siteId,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function getCameraListBySite(siteId, orgId) {
  return sendHttpRequest({
    url: `/camera/cameras?siteId=${siteId}&page.limit=300`,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function batchChangeEnable(cameraIds, enable, siteId, orgId) {
  return sendHttpRequest({
    url: `/camera/cameras/enable`,
    method: "patch",
    data: {
      camIds: cameraIds,
      enable,
      siteId,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function getNvrById(nvrId, orgId) {
  return sendHttpRequest({
    url: `/device/nvrs/${nvrId}`,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}
